import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/system";
import { AuthenticatedContext, ModuleContext } from "../../App";
import { GET_DASHBOARD } from "../../graphql/queries";
import { ContainerPaper, DashboardContainer } from "../../components";

const Dashboard = () => {
  const value = useContext(AuthenticatedContext);
  const { setLoading, userRole } = React.useContext(AuthenticatedContext);
  const { moduleSettings, setModuleSettings, exitSitting } =
    useContext(ModuleContext);
  const history = useHistory();

  function goToPlacement(placement) {
    const type = getStatus(placement);
    if (type === "Start" || type === "Resume" || type === "Review") {
      setModuleSettings({
        ...moduleSettings,
        selectedModule: placement,
        moduleType: "Placement",
      });
    } else {
      setModuleSettings({
        ...moduleSettings,
        selectedModule: placement,
        moduleType: "Diagnostic",
      });
    }
    if (type === "Start" || type === "Start Diagnostic Test") {
      history.push("/instructions");
    } else if (
      type === "Resume" ||
      type === "Resume Diagnostic Test" ||
      type === "Review"
    ) {
      history.push("/placement-question");
    }
  }

  function goToDiagnostic(program) {
    setModuleSettings({
      ...moduleSettings,
      selectedModule: program,
      moduleType: "Diagnostic",
    });
    if (program.DiagnosticSittings.length === 0) {
      history.push("/instructions");
    } else {
      history.push("/placement-question");
    }
  }

  // function goToTraining(training) {
  //   const type = getTrainingStatus(training);
  //   setModuleSettings({
  //     ...moduleSettings,
  //     selectedModule: training,
  //     moduleType: "Training",
  //   });
  //   if (type === "Start") {
  //     history.push("/instructions");
  //   } else if (type === "Resume" || type === "Review") {
  //     history.push("/training-question");
  //   }
  // }

  // async function goToAssessment(assessment) {
  //   const type = getAssessmentStatus(assessment);
  //   setModuleSettings({
  //     ...moduleSettings,
  //     selectedModule: assessment,
  //     moduleType: "Assessment",
  //   });

  //   if (type === "Start") await createSitting(assessment?.id, "Assessment");
  //   history.push("/assessment-question");
  // }

  function getStatus(placement) {
    if (placement.Sittings.length === 0) {
      return "Start";
    } else if (!placement.Sittings[0].isCompleted) {
      return "Resume";
      // } else if (
      //   placement.Sittings[0].isCompleted &&
      //   placement.DiagSittings.length === 0 &&
      //   placement.isDiagnostic
      // ) {
      //   return "Start Diagnostic Test";
      // } else if (
      //   placement.Sittings[0].isCompleted &&
      //   !placement.DiagSittings[0]?.isCompleted &&
      //   placement.isDiagnostic
      // ) {
      //   return "Resume Diagnostic Test";
    } else if (placement.Sittings[0].isCompleted) {
      return "Review";
    } else {
      return "";
    }
  }

  // function getTrainingStatus(training) {
  //   if (training.TrainingSittings.length === 0) {
  //     return "Start";
  //   } else if (!training.TrainingSittings[0].isCompleted) {
  //     return "Resume";
  //   } else if (training.TrainingSittings[0].isCompleted) {
  //     return "Review";
  //   } else {
  //     return "";
  //   }
  // }

  // function getAssessmentStatus(assessment) {
  //   if (assessment.Sittings.length === 0) {
  //     return "Start";
  //   } else if (!assessment.Sittings[0].isCompleted) {
  //     return "Resume";
  //   } else if (assessment.Sittings[0].isCompleted) {
  //     return "Review";
  //   } else {
  //     return "";
  //   }
  // }

  function enableDiagnostic(placements) {
    const incomplete = placements.find((p) => {
      return p.Sittings.length === 0 || p.Sittings[0].isCompleted === false
        ? p
        : null;
    });
    if (incomplete) return false;
    return true;
  }

  const handleExitSitting = useCallback(() => {
    exitSitting();
  }, []);

  useEffect(() => {
    handleExitSitting();
  }, [handleExitSitting]);

  return (
    <ContainerPaper>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {value.userRole === "Student" ? (
          <Typography color="black" gutterBottom variant="h4" sx={{ mb: 2 }}>
            Welcome back{" "}
            {value.user && `${JSON.parse(value.user).student_givenname} (${JSON.parse(value.user).student_login})`} 👋
          </Typography>
        ) : (
          <Typography color="primary" gutterBottom variant="h4" sx={{ mb: 2 }}>
            {value.userRole} Dashboard
          </Typography>
        )}
      </Box>

      {userRole === "Student" && <DashboardContainer />}
    </ContainerPaper>
  );
};

export default Dashboard;
